module.exports = __webpack_public_path__ + "static/media/buddy_bundle-mb-fr.03b447a0.jpg";